import $http from "../axios";

const state = {
  categories: []
};

const getters = {
  categories(state) {
    return state.categories;
  }
};

const actions = {
  getCategories({ commit }) {
    return new Promise((resolve, reject) => {
      $http
        .get("get-categories")
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_CATEGORIES", res.data.payload);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_CATEGORIES(state, payload) {
    state.categories = payload.categories;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
